import { removePrivateBalanceQueries } from "@src/components/DefuseSDK/features/account/queries/privateBalanceQueries"
import { logoutPrivateIntents } from "@src/components/DefuseSDK/features/machines/privateIntents"
import { usePrivateModeStore } from "@src/stores/usePrivateModeStore"

export function teardownPrivateMode() {
  usePrivateModeStore.setState({
    isPrivateModeEnabled: false,
    authenticatedIntentsUserId: null,
  })
  removePrivateBalanceQueries()
  void logoutPrivateIntents()
}
